"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/es/select/style");
var _select = _interopRequireDefault(require("antd/es/select"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _default = exports.default = function _default() {
  let Comp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _select.default;
  return class extends _react.Component {
    constructor() {
      super(...arguments);
      _defineProperty(this, "handleChange", value => {
        const {
          onChange = () => {}
        } = this.props;
        if (value && value.key) {
          return onChange(value.key);
        }
        return onChange(value);
      });
    }
    render() {
      const {
        label,
        ...rest
      } = this.props;
      if (rest.labelInValue) {
        return /*#__PURE__*/_react.default.createElement(Comp, rest);
      }
      const props = {
        ...rest
      };
      if (rest.labelInValue) {
        return /*#__PURE__*/_react.default.createElement(Comp, rest);
      }
      const {
        optionLabelProp = "children"
      } = rest;
      if (rest.value) {
        const childrens = _react.default.Children.toArray(rest.children);
        const child = childrens.find(c => c.props.value === rest.value);
        props.onChange = this.handleChange;
        props.labelInValue = true;
        props.value = {
          key: rest.value,
          label: child ? child.props[optionLabelProp] : label
        };
      }
      return /*#__PURE__*/_react.default.createElement(Comp, props);
    }
  };
};